import LoadingSpinner from '@components/LoadingSpinner'
import useTypedTranslation from '@hooks/useTypedTranslation'

import type { TranslationKey } from '@/i18n'

interface StandaloneLoadingSpinnerProps {
  i18nKey?: TranslationKey
}

function StandaloneLoadingSpinner({ i18nKey }: StandaloneLoadingSpinnerProps) {
  const { t } = useTypedTranslation()

  return (
    <div className="flex w-full items-center justify-center">
      <LoadingSpinner label={i18nKey && t(i18nKey)} />
    </div>
  )
}

export default StandaloneLoadingSpinner